/** @format */

import axios from "axios";
import { BASE_URL } from "../Host";

export const getDashboardStats = async () => {
	const res = await axios.get(BASE_URL + "/admin/user/dashboard/stats");
	return res;
};


